var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"warehouse"},[_c('category-title',{attrs:{"category":_vm.category}}),_c('router-view'),(_vm.isAuthenticated)?_c('faq-bar'):_vm._e(),_c('be-customer-card-horizontal',{attrs:{"card":"registrationHome"}}),_c('newsletter-horizontal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }